<template>
  <div class="step-container form">
    <div class="row center">
      <h3 class="step-header">5. Your contact details</h3>
    </div>
    <div class="row center">
      <h4 class="step-sub-header">We can send you all the details and terms</h4>
    </div>

    <validation-observer v-slot="{ handleSubmit }">
      <form ref="form" method="post" enctype="multipart/form-data"
            @submit.prevent="handleSubmit(submit)">
        <div class="row">
          <validation-provider class="provider" v-slot="{ errors }" name="first name" rules="required" slim>
            <label for="first_name" class="form-input half">
              <input type="text" id="first_name" name="first_name" placeholder="First Name (Required)"
                     v-model="first_name" :class="{ error: errors.length }" @blur="recordEntry('first_name')">
            </label>
          </validation-provider>

          <input type="text" name="cover_plan_id" class="hidden" v-model="plan.id">
          <input type="text" name="upcosts" class="hidden" v-model="upcostList">
          <input v-if="discountModel" type="text" name="reference_code_id" class="hidden" v-model="discountModel.id">

          <validation-provider class="provider" v-slot="{ errors }" name="last name" rules="required" slim>
            <label for="last_name" class="form-input half">
              <input type="text" id="last_name" name="last_name" placeholder="Last Name (Required)" v-model="last_name"
                     :class="{ error: errors.length }" @blur="recordEntry('last_name')">
            </label>
          </validation-provider>
        </div>
        <div class="row">
          <validation-provider class="provider" v-slot="{ errors }" name="email address" rules="required" slim>
            <label for="email" class="form-input">
              <input type="email" id="email" name="email" placeholder="Email Address (Required)" v-model="email"
                     :class="{ error: errors.length }" @blur="recordEntry('email')">
            </label>
            <div><small class="error" v-if="errors.length > 0">Please enter a valid email address</small></div>
          </validation-provider>
        </div>
        <div class="row">
          <label for="phone" class="form-input">
            <input type="text" id="phone" name="phone_number" placeholder="Phone Number (Optional)" v-model="phone" @blur="recordEntry('phone_number')">
          </label>
        </div>
        <div class="row center spaced">
          <button type="submit" class="submit-button"><span>Submit</span></button>
        </div>
        <div class="row center back">
          <span @click="$emit('back')">Back</span>
        </div>
      </form>
    </validation-observer>
  </div>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver
} from 'vee-validate/dist/vee-validate.full';

export default {
  name: "StepFive",
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    base: {
      type: String,
      required: true,
    },
    plan: {
      type: Object,
      required: true,
    },
    currentFirstName: {
      type: String,
      default: '',
    },
    currentLastName: {
      type: String,
      default: '',
    },
    currentEmail: {
      type: String,
      default: '',
    },
    currentPhone: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      first_name: this.currentFirstName,
      last_name: this.currentLastName,
      email: this.currentEmail,
      phone: this.currentPhone,
    }
  },
  mounted() {
    window.dataLayer.push({
      event: 'boilerCoverContactDetailsReached',
      category: 'Boiler Cover Calculator',
      action: 'Reached Contact Details',
      label: 'Boiler Cover Plan Direct Debit Reached',
      boilerPlanType: this.plan.name,
    });
  },
  methods: {
    recordEntry(type){
      if (this[type]){
        window.dataLayer.push({
          event: 'boilerCoverContactDetailsEntry',
          category: 'Boiler Cover Calculator',
          action: 'Detail Field Entered',
          label: 'Boiler Cover Plan Detail Field Entered',
          fieldType: type,
        });
      }

    },
    submit() {
      this.$emit('submit', {
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        phone: this.phone,


      });
    },
  },
}
</script>

<style lang="scss" scoped>
.form {
  max-width: 1000px;
  margin-left: auto !important;
  margin-right: auto !important;
}

h2 {
  font-size: 1.8rem;
  display: block;
  color: #444444;
  font-weight: normal;
  text-align: center;
  margin: 1rem 0;

  &::before {
    display: none;
  }
}

.header {
  text-align: center;
  margin: 0 auto;

  h3 {
    margin: 0.5rem;

    span {
      text-decoration: underline;
      font-size: 3rem;
      color: #444444;
      font-weight: bold;
    }

    small {
      font-size: 1.5rem;
      color: #444444;
      font-weight: normal;
    }
  }

  small {
    color: #444444;
  }

  p {
    margin: 1rem 0;
    padding: 0 20%;
    line-height: 1.5rem;
  }

}

form {
  padding: 0 20%;
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
  box-sizing: border-box;
}

.form-input {
  width: 100%;
  margin: 0.5rem 0;
  display: block;

  &.flex {
    display: flex;
    justify-content: space-between;
    width: 100%;

    input {
      width: 90%;
      font-family: sans-serif;
      padding: 0.5rem 0.4rem;
      border: 1px solid #000;
      outline: none;
    }

    button {
      background-color: #FF5B18;
      color: #FFF;
      padding: 0 1rem;
      border-radius: 5px;
      cursor: pointer;
      border: none;
      outline: none;
      margin-left: 1rem;
    }
  }

  input {
    width: 100%;
    font-family: sans-serif;
    padding: 0.5rem 0.4rem;
    border: 1px solid #000;
    outline: none;

    &.error {
      border: 1px solid red;
    }
  }

  &.half {
    width: 49%;
  }
}

.checkbox {
  margin: 0.5rem 0;

  span.error {
    color: red;
  }

  input {
    margin-right: 0.2rem;
  }
}

.total {
  margin-top: 2rem;
  padding: 0.5rem 1rem;
  border: 1px solid #444444;
  color: #444444;
  font-size: 1.5rem;
  font-weight: normal;
}

.provider {
  width: 100%;
}

.logos {
  margin: 1rem 20%;
  width: 60%;
  justify-content: center;

  a, span {
    margin: 0.5rem;

    img {
      height: 40px;
      transition: 0.4s;
    }

    &:hover {
      img {
        transform: scale(1.1);
        transition: 0.4s;
      }
    }
  }
}

.features {
  background-color: #F5F5F5;
  padding: 0.5rem 1rem;
  margin: 1rem 20%;

  .bullet-points {
    margin: 0;
    text-align: left;
    list-style: none;

    li {
      padding-bottom: 0.2rem;
      margin-bottom: 0.2rem;
      border-bottom: 1px dashed #D3D3D3;
      font-size: 1.2rem;
      display: flex;

      .material-icons {
        margin-right: 0.5rem;
      }
    }
  }
}

.spaced {
  margin: 2rem 0;
}

.red {
  color: red;
}

.green {
  color: green;
}

.hidden {
  display: none;
}

.success-message {
  color: green;
  margin: 0.5rem 0;
}

.error-message {
  color: red;
  margin: 0.5rem 0;
}

.included-heading {
  display: flex;
  align-items: center;
  justify-content: center;

  .included-icon {
    width: 50px;
    height: 50px;
    margin-right: 0.2rem;
  }
}


@media only screen and (max-width: 860px) {
  form {
    padding: 0 10px;
  }
  .form-input {
    &.half {
      width: 100%;
    }
  }
  .logos {
    margin: 1rem 10px;
    width: 100%;
    justify-content: center;
  }

  .features {
    background-color: #F5F5F5;
    padding: 0.5rem 1rem;
    margin: 1rem 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/steps/StepFive.vue